module.exports = __webpack_public_path__ + "img/nt115-03-81-1.prt.c3d04da5.jpg";